import { RootState } from '@checkout/state';
import * as React from 'react';
import { Fragment } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { OrderHistoryList } from '..';
import { MembershipHeader } from '../../presentational';
import messages from './../../../i18n/base-en';

interface IOwnProps {}

interface IConnectedProps {}

interface IConnectetDispatchProps {}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class OrderHistory extends React.Component<Props, {}> {

  render() {
    const { intl } = this.props;
    const { formatMessage } = intl;
    
    return (
      <Fragment>
        <MembershipHeader 
          title={formatMessage(messages.membership_orders_history_title)} 
          subTitle={formatMessage(messages.membership_orders_history_subtitle)} 
        />
        <OrderHistoryList />
      </Fragment>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({}),
    {}
  )
)(OrderHistory);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/OrderHistory/OrderHistory.tsx